import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';

@Component({
    selector: 'mojo-global-not-found',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './global-not-found.component.html',
    styleUrls: ['./global-not-found.component.scss'],
    standalone: false
})
export class GlobalNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
